import React from 'react';
// @ts-ignore
import { Helmet, } from 'react-helmet';
import favicon from '../images/favicon.png';
import GtmContainer from './GtmContainer';

const PageHead = ({
  enablegtm = true,
}) => (
  <React.Fragment>
    {enablegtm && <GtmContainer />}
    <Helmet htmlAttributes={{ lang: 'en', }}>
      <title>Syndicated Editorial Widget</title>
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="description" content="Syndicated Editorial Widget" />
      <meta name="referrer" content="origin" />
      <meta name="viewport" content="width=device-width, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no" />
      <link rel="icon" type="image/png" sizes="16x16" href={favicon} />
    </Helmet>
  </React.Fragment>
);

export default PageHead;
